const MANHATTAN_PREFIXED_SHIPMENT_ID_PATTERN = /\b(?:SHI|CS)\d{9}\b/i;
const MANHATTAN_NUMERIC_SHIPMENT_ID_PATTERN = /^\d{8}$/;

export function normalizeManhattanShipmentId(raw: string): string {
  const normalizedRaw = raw.trim();
  const shipmentId =
    normalizedRaw.match(MANHATTAN_PREFIXED_SHIPMENT_ID_PATTERN)?.[0] ??
    normalizedRaw.match(MANHATTAN_NUMERIC_SHIPMENT_ID_PATTERN)?.[0];

  return shipmentId?.toUpperCase() ?? '';
}
